import React from 'react';
import { Button } from '@/components/ui/button';
import { X, Pin, PinOff } from 'lucide-react';
import {
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';

interface DrawerHeaderProps {
  title: string;
  description: string;
  isPinned: boolean;
  onClose: () => void;
  onPinToggle: () => void;
  variant?: 'pinned' | 'sheet';
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  title,
  description,
  isPinned,
  onClose,
  onPinToggle,
  variant = 'sheet',
}) => {
  if (variant === 'pinned') {
    return (
      <div className="p-4 border-b border-border bg-background flex items-center gap-2 shrink-0">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="h-8 w-8"
        >
          <X className="h-4 w-4" />
        </Button>
        
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold truncate">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground truncate">
            {description}
          </p>
        </div>

        <Button
          variant={isPinned ? 'default' : 'ghost'}
          size="icon"
          onClick={onPinToggle}
          className="h-8 w-8 shrink-0"
        >
          {isPinned ? <Pin className="h-4 w-4" /> : <PinOff className="h-4 w-4" />}
        </Button>
      </div>
    );
  }

  return (
    <SheetHeader className="p-4 border-b border-border space-y-0">
      <div className="flex items-center gap-2">
        <div className="flex-1 min-w-0">
          <SheetTitle className="text-base truncate">
            {title}
          </SheetTitle>
          <SheetDescription className="truncate">
            {description}
          </SheetDescription>
        </div>

        <Button
          variant="ghost"
          size="icon"
          onClick={onPinToggle}
          className="h-8 w-8 shrink-0"
        >
          <PinOff className="h-4 w-4" />
        </Button>
      </div>
    </SheetHeader>
  );
};

